import React, { Component } from 'react';

class Links extends Component {
  getOfficialLinks() {
    let links = this.props.links.map((link, index) => {
      let l;
      if(link.tax_value === "Official Site") {
        l = <a key={index} className="button medium official-link" href={link.link}>Official Site</a>;
      } else if(link.tax_value === "Team Schedule") {
        l = <a key={index} className="button medium official-link" href={link.link}>Team Schedule</a>;
      } else if(link.tax_value === "Team Roster") {
        l = <a key={index} className="button medium official-link" href={link.link}>Team Roster</a>;
      }
      return l;
    });
    return links;
  }
  getSocialLinks() {
    let links = this.props.links.map((link, index) => {
      let l;
      if(link.tax_value === "Other") {
        l = <a key={index} href={link.link}><img src="https://www.roadtonationals.com/results/imgs/logos/other.png" alt="link" width="48" height="48" /></a>;
      } else if(link.tax_value === "Facebook") {
        l = <a key={index} href={link.link}><img src="https://www.roadtonationals.com/results/imgs/logos/fb.png" alt="link" width="48" height="48" /></a>;
      } else if(link.tax_value === "Twitter") {
        l = <a key={index} href={link.link}><img src="https://www.roadtonationals.com/results/imgs/logos/twitter.png" alt="link" width="48" height="48" /></a>;
      } else if(link.tax_value === "YouTube") {
        l = <a key={index} href={link.link}><img src="https://www.roadtonationals.com/results/imgs/logos/youtube.png" alt="link" width="48" height="48" /></a>;
      } else if(link.tax_value === "Instagram") {
        l = <a key={index} href={link.link}><img src="https://www.roadtonationals.com/results/imgs/logos/instagram.png" alt="link" width="48" height="48" /></a>;
      }
      return l;
    });
    return links;
  }
  render() {
    if(this.props.links.length > 0){
      return (
        <div className="linksBox">
          <div className="row expanded">
            <div className="section-title">Official external links</div>
            <div className="spacer-top10">
            {this.getOfficialLinks()}
            <p className="logo-links">
              {this.getSocialLinks()}
            </p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="linksBox spacer-top10">
          <div className="row expanded">
          </div>
        </div>
      );
    }
  }
}

export default Links;
